import api_client from "./api_client";

const holidayService = {
  /**
   * Récupérer les jours fériés
   */
  getHolidays: async (year = null, holidayType = null) => {
    try {
      const params = {};

      if (year) {
        params.year = year;
      }

      if (holidayType) {
        params.holiday_type = holidayType;
      }

      // IMPORTANT : utiliser /holidays/ avec le slash final
      const response = await api_client.get("/holidays", {
        params,
      });

      return response.data;
    } catch (error) {
      console.error(
        "[HolidayService] Erreur chargement jours fériés:",
        error
      );
      throw error;
    }
  },

  /**
   * Récupérer un jour férié
   */
  getHoliday: async (holidayId) => {
    try {
      const response = await api_client.get(`/holidays/${holidayId}`);
      return response.data;
    } catch (error) {
      console.error("[HolidayService] Erreur chargement jour férié:", error);
      throw error;
    }
  },

  /**
   * Créer un jour férié
   */
  createHoliday: async (holidayData) => {
    try {
      const response = await api_client.post("/holidays/", holidayData);
      return response.data;
    } catch (error) {
      console.error("[HolidayService] Erreur création jour férié:", error);
      throw error;
    }
  },

  /**
   * Modifier un jour férié
   */
  updateHoliday: async (holidayId, holidayData) => {
    try {
      const response = await api_client.put(
        `/holidays/${holidayId}`,
        holidayData
      );
      return response.data;
    } catch (error) {
      console.error("[HolidayService] Erreur modification jour férié:", error);
      throw error;
    }
  },

  /**
   * Supprimer un jour férié
   */
  deleteHoliday: async (holidayId) => {
    try {
      await api_client.delete(`/holidays/${holidayId}`);
      return true;
    } catch (error) {
      console.error("[HolidayService] Erreur suppression jour férié:", error);
      throw error;
    }
  },
};

export default holidayService;